import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoans } from "../../actions/loanActions";
import { loadPageData } from "../../actions";
import SCCustomerLoansTable from "./css";
import {
  SCCustomerLoans,
  SCCustomerNoLoans,
} from "./css";
import {
  LOAN_TABLE_HEADER,
} from "../../util/constants/types";
import Loader from "../Common/Loader";
import Footer from "../Footer";
import { NavWithComponent } from "../Nav";
import { RootState } from "../../reducers";
import TableWithPagination from "../TableWithPagination/TableWithPagination";

type LoanSelector = {
  loans?: any[];
  loading: boolean;
  error: {
    message: string;
  };
  customer: any;
}


const Loan: React.FC<{}> = () => {
  const dispatch = useDispatch();

  const { customer, error, loading, loans } = useSelector<RootState, LoanSelector>(state => ({
    customer: state.pageData.customer,
    error: state.loans.error,
    loading: state.loans.loading,
    loans: state.loans.items,
  }));

  useEffect(() => {
    if (!customer) {
      dispatch(loadPageData());
    }
    if (!loans && !error)  {
      dispatch(fetchLoans());
    }
  }, [dispatch, customer, loans]);
  

  if (error) {
    return <div>Error! {error.message}</div>;
  }

  if (loading) {
    return <Loader text="Loading..." />;
  }

  const transformedLoans = loans?.map((loan) => ({
    "ID": loan.ID,
    "loanName": loan.loanName,
    "status": loan.status,
    "paidLoanAmount": loan.paidLoanAmount,
    "balanceRemaining": loan.balanceRemaining,
    "nextRepaymentDate": loan.nextRepaymentDate,
    "loanViewButtonUrl": loan.loanViewButtonUrl,
  }));

  return (
    <>
    <NavWithComponent title="My Loans" activePage="/my-loans" />
      {(loans ?? []).length > 0 ? (
        <SCCustomerLoans>
          <TableWithPagination
            tableHeaders={LOAN_TABLE_HEADER}
            rawData={transformedLoans}
            initialSortField="loanNumber"
            Table={SCCustomerLoansTable}
          />
        </SCCustomerLoans>
      ) : (
        <SCCustomerNoLoans>
          <div className="no-loans-image" />
          <div>
            You don't currently have any Payright PLUS Loans. 
            Click <a href="https://payright.com.au/payright-plus/" target="_blank">here</a> for some information on our new product.
          </div>
        </SCCustomerNoLoans>
      )}
      <Footer />
    </>
  );
};

export default Loan;
